import React from 'react';
import styles from '../../assets/styles/Onboarding/AccountInReview.module.scss';
import { MimaButton, MimaText } from '../../components';
import ReviewImg from '../../assets/img/underReview.png';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { mimaPayLogo } from '../../assets/img';

const AccountInReview = ({ validationSchema, onSubmit, loading }) => {
	const navigate = useNavigate();

	const goToLanding = () => {
		navigate(constant.Routes.Home);
	};

	return (
		<div className={styles.container}>
			<img
				src={mimaPayLogo}
				className={styles.logo}
				onClick={goToLanding}
				alt="logo"
			/>
			<img
				src={ReviewImg}
				alt="Account in review"
				className={styles.inReview}
			/>
			<MimaText variant="h3" color="var(--color-primary)" mt={1}>
				Thank you for signing up!
			</MimaText>
			<MimaText mt={1} width={40} align="center">
				Your account is undergoing review and we will respond shortly
			</MimaText>
			<MimaButton
				title="Go back Home"
				buttonColor="var(--color-dark)"
				onClick={goToLanding}
				mt={3}
			/>
		</div>
	);
};

export default AccountInReview;
